// extracted by mini-css-extract-plugin
export var attribution = "_ak-4";
export var authorName = "_ak-5";
export var quote = "_ak-3";
export var testimonial = "_ak-2";
export var trustedBy = "_ak-0";
export var trustedByLabel = "_ak-1";